import { defineStore } from 'pinia';
import ReservasApiService from '../services/api/ReservasApiService';
import { shallowRef } from 'vue';

export const proximasExperiencias = defineStore('proximasExperiencias', {
  state: () => ({
    grupos: shallowRef(null),
    grupoSeleccionado: shallowRef(null),
    isGrupoB2B: shallowRef(null),
    _grupoDetailed: shallowRef(false),
  }),
  getters: {
    getGrupoSeleccionado(state) {
      return state.grupoSeleccionado;
    },
    getGrupos(state) {
      return state.grupos;
    },
  },
  actions: {
    async loadProximasExperiencias() {
      await ReservasApiService.getProximasExperiencias().then(res => {
        this.grupos = res;
      });
    },
    async setGrupoSeleccionado(grupoId, forceDetailed = false, isB2b = false) {
      let index = -1;

      if (
        this.grupoSeleccionado !== null &&
        this.grupoSeleccionado.id === grupoId &&
        this.isGrupoB2B === isB2b &&
        (this._grupoDetailed || !forceDetailed)
      ) {
        return this.grupoSeleccionado;
      } else if (this.grupos != null && !forceDetailed) {
        index = this.grupos.findIndex(grupo => {
          return grupo.id === grupoId && grupo.b2b === isB2b;
        });
        if (index !== -1) {
          this.grupoSeleccionado = this.grupos[index];
          this.isGrupoB2B = isB2b;
          this._grupoDetailed = false;
          return;
        }
      }

      this.grupoSeleccionado = isB2b
        ? await ReservasApiService.getGrupoByInvitacionGrupo(grupoId)
        : await ReservasApiService.getGrupo(grupoId);
      this.isGrupoB2B = isB2b;
      this._grupoDetailed = true;
    },
  },
});
